import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';

import TopBar from './components/TopBar.jsx';
import Homepage from './pages/Homepage';
import Report from './pages/Report';
import WWA from './pages/WWA.jsx';
import WWO from './pages/WWO.jsx';
import FAQ from './pages/FAQ.jsx';
import News from './pages/News.jsx';
import Article1 from './pages/Article1.jsx';
import Article2 from './pages/Article2.jsx';
import Article3 from './pages/Article3.jsx';
import Contact from './pages/Contact.jsx';
import Terms from './pages/Terms.jsx';
import Privacy from './pages/Privacy.jsx';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { useGSAP } from '@gsap/react';
import withScrollToTop from './components/withScrollToTop.jsx';

///ANIMATED ROUTES IMPORT
import AnimatedRoutes from './components/AnimatedRoutes.jsx';

const HomepageL = withScrollToTop(Homepage);
const FAQL = withScrollToTop(FAQ);
const WWAL = withScrollToTop(WWA);
const WWOL = withScrollToTop(WWO);
const NewsL = withScrollToTop(News);
const ContactL = withScrollToTop(Contact);
const ReportL = withScrollToTop(Report);
const Article1L = withScrollToTop(Article1);
const Article2L = withScrollToTop(Article2);
const Article3L = withScrollToTop(Article3);
const TermsL = withScrollToTop(Terms);
const PrivacyL = withScrollToTop(Privacy);

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, useGSAP);

function App() {
  return (
    <Router>
      <TopBar />
      {/* <Routes> */}
        {/* <Route path="/" element={<HomepageL />} />
        <Route path="/home" element={<HomepageL />} />
        <Route path="/faq" element={<FAQL />} />
        <Route path="/news" element={<NewsL />} />
        <Route path="/terms" element={<TermsL />} />
        <Route path="/privacy" element={<PrivacyL />} />
        <Route path="/article" element={<ArticleL />} />
        <Route path="/contact" element={<ContactL />} />
        <Route path="/what-we-offer" element={<WWOL />} />
        <Route path="/financial-report" element={<ReportL />} />
        <Route path="/who-we-are" element={<WWAL />} />
        <Route path="*" element={<Navigate to="/" />} /> */}
      {/* </Routes> */}
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
